<template>
  <div>
    <div class="complianceChecks-title">
      <div>{{ $t("alarms.complianceChecks.compliance") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="['monitor:complianceChecks:add_alert_rule']"
          @click="addOrUpdateHandle"
          >{{ $t("alarms.complianceChecks.addComplianceChecks") }}</Button
        >
        <add-or-update-compliance-checks-warning
          v-if="addOrUpdateVisible"
          ref="addOrUpdate"
        ></add-or-update-compliance-checks-warning>
      </div>
    </div>
    <template>
      <Tabs size="small" v-model="currentTab" :animated="false">
        <TabPane
          :label="$t('alarms.complianceChecks.Overview')"
          name="tabOverview"
        >
          <compliance-checks-list></compliance-checks-list>
        </TabPane>
        <TabPane :label="$t('alarms.common.alertRule')" name="tabAlarmRule">
          <div class="complianceChecks-top">
            <compliance-checks-warning-search></compliance-checks-warning-search>
          </div>
          <table-compliance-checks-warning></table-compliance-checks-warning>
        </TabPane>
        <TabPane
          :label="$t('alarms.complianceChecks.WhiteList')"
          name="tabWhitelist"
        >
          <div class="complianceChecks-top">
            <compliance-checks-whitelist-search></compliance-checks-whitelist-search>
          </div>
          <table-compliance-checks-whitelist></table-compliance-checks-whitelist>
        </TabPane>
      </Tabs>
    </template>
  </div>
</template>

<script>
import ComplianceChecksList from "../compliance_checks/complianceChecks_list/ComplianceChecksList";
import ComplianceChecksWarningSearch from "../compliance_checks/complianceChecks_monitor/ComplianceChecksWarningSearch";
import TableComplianceChecksWarning from "../compliance_checks/complianceChecks_monitor/TableComplianceChecksWarning";
import AddOrUpdateComplianceChecksWarning from "../compliance_checks/complianceChecks_monitor/AddOrUpdateComplianceChecksWarning";
import ComplianceChecksWhitelistSearch from "./complianceChecks_whitelist/ComplianceChecksWhitelistSearch";
import TableComplianceChecksWhitelist from "./complianceChecks_whitelist/TableComplianceChecksWhitelist";

export default {
  name: "ComplianceChecks",
  components: {
    ComplianceChecksList,
    ComplianceChecksWarningSearch,
    TableComplianceChecksWarning,
    AddOrUpdateComplianceChecksWarning,
    ComplianceChecksWhitelistSearch,
    TableComplianceChecksWhitelist
  },
  data() {
    return {
      currentTab: "",
      addOrUpdateVisible: false
    };
  },
  methods: {
    // 添加报警规则
    /**********************************************************************************/
    addOrUpdateHandle: function() {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init();
      });
    },
    changeCurrentTab: function(tabName) {
      this.currentTab = tabName;
    }
  }
};
</script>

<style scoped>
.complianceChecks-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.complianceChecks-title > div:nth-child(1) {
  float: left;
}
.complianceChecks-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.complianceChecks-top {
  width: 100%;
  height: 32px;
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/compliance_checks/ComplianceChecks.vue